// import { ConfigProvider, App as AntApp, theme } from 'antd';
// import QueryProvider from './services/react-query';
// import { useSelector } from 'react-redux';
// import { useEffect } from 'react';
// import en from './Localization/en';
// import ar from './Localization/ar';
// import RoutesWrapper from './Routes/RoutesWrapper';
// import "aos/dist/aos.css";

// function App() {
//   const { currentLang } = useSelector((state) => state.user);
//   // console.log(currentLang);
//   const t = currentLang === 'en' ? en : ar;
//   useEffect(() => {
//     if (currentLang) {
//       document
//         .getElementsByTagName('html')[0]
//         .setAttribute('lang', currentLang);
//     }
//   }, [currentLang]);
//   return (
//     <QueryProvider>
//       <ConfigProvider
//         direction={currentLang === 'en' ? 'ltr' : 'rtl'}
//         theme={{
//           algorithm:  theme.darkAlgorithm ,
//           token: {
//             colorPrimary: '#3FE6FF',
//             colorLinkHover: '#3FE6FF', // color link
//             colorLink: '#fff',
//             colorBgLayout: '#000', // background layout
//             colorBgContainer: '#8080801A', // background table && card
//             // contentFontSize: 20,
//             // paddingBlock: 19,
//             // paddingInline: 32,
//             fontWeight: 600,
//             // colorInfo: '#faad14',
//             borderRadius: 10,
//             colorText: '#fff',
//             fontSize: 16,
//             // controlHeight: 40,
//             // colorBtnColor: '#fff',
//             // secBtnBg: '#F8F5FF',
//             // secColor: '#74788d',
//             // defaultBg: '#EEF0FF',
//             // defaultColor: '#4F5062',
//             // defaultBorderColor: '#B0B0C0',
//             // thirdColor: '#59A6ED',
//             // Accent: '#EBF2FA',
//             // line: '#CFD8E3',
//             // grayTxt: '#595959',
//             // colorPrimaryBgHover: '#421db192',
//             // colorPrimaryHover: '#421db192',
//             // colorTextDescription: '#595959',
//             // colorPrimaryActive: '#421db192',
//             // colorPrimaryText: '#343a40',
//             // colorPrimaryTextActive: '#343a40',
//             // colorPrimaryTextHover: '#343a40',
//             colorSuccess: '#0ac074',
//             colorSuccessBg: '#E9FFDA',
//             colorWarning: '#ff9d00',
//             colorWarningBg: '#FFF4E2',
//             colorError: '#ff3d60',
//             colorErrorBg: '#FFE7E4',
//             colorTextBase: '#fff',
//             // colorFillQuaternary: '#ebf2fa',
//             // colorFillSecondary: '#ebf2fa',
//             // colorPrimaryBg: '#e6fcf9',
//             // fontSizeXL: 18,
//             // fontSizeHeading5: 16,
//             // fontSizeHeading4: 18,
//             // fontSizeHeading3: 22,
//             // fontSizeHeading2: 25,
//             // fontSizeHeading1: 32,
//             // marginMD: 24,
//             // wireframe: false,
//             // marginLG: 32,
//             // marginXL: 40,
//             // paddingMD: 24,
//             // paddingLG: 32,
//             // paddingXL: 40,
//             // borderRadiusSM: 8,
//             // borderRadiusMD: 10,
//             // borderRadiusLG: 12,
//             // borderRadiusXS: 14,
//             // colorBgElevated: '#ffffff',
//             // colorPrimaryBorder: '#0bb197',
//             // colorPrimaryBorder: '#421db1',
//           },
//         }}
//       >
//         <AntApp>
//           <RoutesWrapper t={t} />
//         </AntApp>
//       </ConfigProvider>
//     </QueryProvider>
//   );
// }

// export default App;
import { ConfigProvider, App as AntApp, theme } from 'antd';
import QueryProvider from './services/react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom'; // إضافة useLocation
import en from './Localization/en';
import ar from './Localization/ar';
import RoutesWrapper from './Routes/RoutesWrapper';
import 'aos/dist/aos.css';
import { setCurrentLang } from './Store/user/UserSlice';
import ScrollToTop from './Hooks/ScrollToTop';
import { Helmet } from 'react-helmet';

function App() {
  const { currentLang } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const location = useLocation();
  // const t = currentLang === 'en' ? en : ar;
  const t = en;

  useEffect(() => {
    const pathLang = location.pathname.startsWith('/ar') ? 'ar' : 'en';
    if (currentLang !== pathLang) {
      dispatch(setCurrentLang(pathLang));
    }
    document.getElementsByTagName('html')[0].setAttribute('lang', pathLang);
  }, [location.pathname, currentLang, dispatch]);

  return (
    <QueryProvider>
      <Helmet>
        <title>Merse</title>
      </Helmet>
      <ConfigProvider
        direction={currentLang === 'en' ? 'ltr' : 'rtl'}
        theme={{
          algorithm: theme.darkAlgorithm,
          token: {
            colorPrimary: '#3FE6FF',
            colorLinkHover: '#3FE6FF',
            colorLink: '#fff',
            colorBgLayout: '#000',
            colorBgContainer: '#8080801A',
            fontWeight: 600,
            borderRadius: 10,
            colorText: '#fff',
            fontSize: 16,
            colorSuccess: '#0ac074',
            colorSuccessBg: '#E9FFDA',
            colorWarning: '#ff9d00',
            colorWarningBg: '#FFF4E2',
            colorError: '#ff3d60',
            colorErrorBg: '#FFE7E4',
            colorTextBase: '#fff',
          },
        }}
      >
        <AntApp>
          <ScrollToTop />
          <RoutesWrapper t={t} />
        </AntApp>
      </ConfigProvider>
    </QueryProvider>
  );
}

export default App;
